import { createConversationClient } from "@/api/agent-conversation";

/**
 * A conversa do agente com uma SSCUI do Nó 03 (spec 2026-10-09, §6.4; spec 2026-10-12,
 * §6.7). Tipos, leitor do SSE e rotas são os do módulo genérico; o que é do Nó 03 é o
 * segmento `sscui` da rota.
 *
 * Recusas da abertura, com o código no `detail`: 403 `item_not_approved`; 409
 * `conversation_already_open` (conversa do próprio Nó 03), `conversation_open_in_module_config`
 * (conversa aberta no Nó 04), `conversation_open_in_org_structure` (conversa aberta no Nó 02); 412
 * `configuration_not_set`, `no_img_activity`, `cbc_connection_not_configured`.
 */
export const sscuiConversation = createConversationClient("sscui");
